import { useEffect, useState } from "react";
import { useResetPasswordMutation } from "../../../services/RegisterAPI";
import { useGetColorThemeQuery } from "../../../services/commonAPI";
import { useNavigate, useLocation } from "react-router-dom";
import Banner from "./banner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./style.css";

function ResetPasswordForm() {
    const navigate = useNavigate();
    const location = useLocation();

    // Get email from previous step (Forgot Password)
    const email = location.state?.email || "";
    const otp = location.state?.otp || "";

    const [formData, setFormData] = useState({
        password: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    const { data: colorthemeData } = useGetColorThemeQuery();
    const [submitResetPassword, { isLoading }] = useResetPasswordMutation();

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage(null);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    const validateForm = () => {
        let validationErrors = {};
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (!formData.password) {
            validationErrors.password = "Password is required.";
        } else if (!passwordRegex.test(formData.password)) {
            validationErrors.password =
                "Password must be at least 8 characters long, include one uppercase letter, one lowercase letter, one number, and one special character.";
        }

        if (!formData.confirmPassword) {
            validationErrors.confirmPassword = "Confirm Password is required.";
        } else if (formData.password !== formData.confirmPassword) {
            validationErrors.confirmPassword = "Passwords do not match.";
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(null);

        if (!validateForm()) return;

        try {
            let payload = {
                email: email,
                otp: otp,
                password: formData.password,
                password_confirmation: formData.confirmPassword
            }
            const response = await submitResetPassword(payload).unwrap();

            setMessage(response.message);
            if (response.success) {
                setMessageType("success");
                setTimeout(() => {
                    navigate("/login");
                }, 3000);
            } else {
                setMessageType("error");
            }
        } catch (error) {
            setMessage(error.data?.message || "Failed to reset password.");
            setMessageType("error");
        }
    };

    return (
        <>
            <Banner />
            <div className="register-form forgot-password-form">
                <div className="container">
                    <div className="row justify-center">
                        <div className="col-md-6 col-lg-6 col-sm-12">
                            <div className="left-div">
                                <h4>Reset Password</h4>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-20 position-relative">
                                        <label>New Password *</label>
                                        <br />
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="absolute show-hide-pasw-btn"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <FontAwesomeIcon
                                                icon={showPassword ?  faEye : faEyeSlash}
                                            />
                                        </button>
                                        {errors.password && (
                                            <p className="error-message">{errors.password}</p>
                                        )}
                                    </div>

                                    <div className="mb-20 position-relative">
                                        <label>Confirm Password *</label>
                                        <br />
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="absolute show-hide-pasw-btn"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        >
                                            <FontAwesomeIcon
                                                icon={ showConfirmPassword?  faEye : faEyeSlash}
                                            />
                                        </button>
                                        {errors.confirmPassword && (
                                            <p className="error-message">{errors.confirmPassword}</p>
                                        )}
                                    </div>

                                    <button
                                        type="submit"
                                        className="primary-button w-100"
                                        disabled={isLoading}
                                        style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}
                                    >
                                        {isLoading ? "Resetting..." : "Reset Password"}
                                    </button>
                                </form>

                                {message && (
                                    <p
                                        className={
                                            messageType === "success"
                                                ? "success-message"
                                                : "error-message"
                                        }
                                    >
                                        {message}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ResetPasswordForm;
